export default "__VITE_ASSET__aa141ce4__"